import { render, staticRenderFns } from "./NewsMenu.vue?vue&type=template&id=2886f295"
import script from "./NewsMenu.vue?vue&type=script&lang=js"
export * from "./NewsMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports